import 'babel-polyfill';
import './fonts/icomoon/style.css';
import './styles/Main.scss';
import './scripts/Main';
import './scripts/modernizr-custom';
import './scripts/UglyFixAnchorLoad';

const ctx = require.context('../../components', true, /\.js$/);


ctx.keys().forEach(function(name) {
  return ctx(name);
});

// Images
import './img/logo/weber-shaping-ideas.svg';
import './img/logo/wezilit.svg';
import './img/logo/wezimed.svg';
import './img/logo/wezimould.svg';
import './img/logo/weber-group.svg';

import './img/logo/monochrome/weber.svg';
import './img/logo/monochrome/weber-group.svg';
import './img/logo/monochrome/weber-shaping-ideas.svg';
import './img/logo/monochrome/wezilit.svg';
import './img/logo/monochrome/wezimed.svg';
import './img/logo/monochrome/wezimould.svg';

import './img/video-technical-reasons.jpg';
